import { ReactElement } from 'react'
import { useParams } from 'react-router'
import { ProjectApplicationAssessment } from 'src/screens/shared/application/assessment/ProjectApplicationAssessment'

export const PfPgvApplicationAssessmentIndexPage = (): ReactElement => {
  const { projectId } = useParams()
  const pfPgvId = parseInt(projectId as string)
  return <ProjectApplicationAssessment projectId={pfPgvId} baseUrl="/pf-pgv" />
}
